// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.UpdateStripeLandlordEmailAndPhoneWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UpdateStripeLandlordEmailAndPhoneRequestDto, UpdateStripeLandlordEmailAndPhoneResponseDto } from '../..';

export const UpdateStripeLandlordEmailAndPhoneWebApiHandler_updateStripeLandlordEmailAndPhoneNumber_Path =
  '/api/web/v1/landlord/updateStripeLandlordEmailAndPhoneNumber';

/**
 * Update a landlord's email and phone number in Stripe
 */
export const UpdateStripeLandlordEmailAndPhoneWebApiHandler_updateStripeLandlordEmailAndPhoneNumber = (
  postData: UpdateStripeLandlordEmailAndPhoneRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UpdateStripeLandlordEmailAndPhoneRequestDto,
    UpdateStripeLandlordEmailAndPhoneResponseDto
  >(
    {
      endpoint: UpdateStripeLandlordEmailAndPhoneWebApiHandler_updateStripeLandlordEmailAndPhoneNumber_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
